export const NAMESPACE_AND_TIME_ADDED_INDEX = 'namespace-timeAdded';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const RESILIENCE_DB_NAME = 'analytics-web-client';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const RESILIENCE_STORE_NAME = 'analytics-resilience';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const TIME_TO_PROCESS_AFTER_INDEX = 'timeToBeProcessedAfter';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const TIME_ADDED_INDEX = 'timeAdded';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const RETRY_INDEX = 'retryAttempts';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const INDEXEDDB_TIMEOUT = 15000;

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export enum StoreType {
	INDEXEDDB = 'indexeddb',
	MEMORY = 'memory',
}

// Used to describe how the ResilienceDb should react when there is insufficient storage space.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export enum GuardPolicy {
	// Adds as many items as possible and IGONRES the rest.
	// Only to be used with BulkAdd
	IGNORE = 'ignore',

	// ABANDON the request if not all items can be added.
	ABANDON = 'abandon',

	// EVICT old items to make room for new items if space is tight.
	EVICT = 'evict',
}
